import { createListCollection } from '@chakra-ui/react';
import CustomInputDateTimeRange from '@components/common/inputs/CustomInputDateTimeRange';
import { CustomSelect } from '@components/ui/select/Select';
import { getDateTimeRangeFromPreset } from '@utils/date.utils';
import { useState } from 'react';
import { useIntl } from 'react-intl';

import { DATE_TIME_RANGE_PRESETS, DateTimeRange, DateTimeRangePreset } from '@/types/dateTime.types';

interface DateTimeRangeInputWithPresetsProps {
  range: DateTimeRange;
  onChange: (value: DateTimeRange) => void;
  defaultDateTimeRangePreset?: DateTimeRangePreset;
  placeholder?: string;
}

function DateTimeRangeInputWithPresets({
  range,
  onChange,
  defaultDateTimeRangePreset = 'ROLLING_MONTH',
  placeholder,
}: Readonly<DateTimeRangeInputWithPresetsProps>) {
  const { formatMessage } = useIntl();

  const items = createListCollection({
    items: DATE_TIME_RANGE_PRESETS.map((value) => ({
      value: value,
      label: formatMessage({ id: `time.dateTimeRangePreset.${value}` }),
    })),
  });

  const [dateTimeRangePreset, setDateTimeRangePreset] = useState<DateTimeRangePreset | undefined>(
    defaultDateTimeRangePreset,
  );

  const handlePresetChange = (value: string | null) => {
    if (!value) return;

    const preset = value as DateTimeRangePreset;
    setDateTimeRangePreset(preset);

    if (preset !== 'CUSTOM') {
      onChange(getDateTimeRangeFromPreset(preset));
    }
  };

  const handleDateTimeRangeChange = (range: DateTimeRange) => {
    onChange(range);
    setDateTimeRangePreset('CUSTOM');
  };

  return (
    <>
      <CustomSelect
        placeholder={placeholder}
        collection={items}
        value={dateTimeRangePreset}
        onChange={handlePresetChange}
      />
      <CustomInputDateTimeRange
        range={range}
        singleLine={false}
        showSecond={false}
        onChange={handleDateTimeRangeChange}
      />
    </>
  );
}

export default DateTimeRangeInputWithPresets;
